/// <reference path="../app.ts" />

namespace Cfnc {
    "use strict";


    class SignInRedirectCallBack {
        static controllerId: string = "signInRedirectCallBack";
        static $inject: Array<string> = ["common"];
        constructor(private common: ICommonFactory) {
            common.authentication.completeLogin().then(user => {
                common.authentication.redirectAuthenticated(null, true);
            });
        }
    }
    angular.module("app").controller(SignInRedirectCallBack.controllerId, SignInRedirectCallBack);
}